exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".productInfoWrap .number-input .ivu-input-number-input {\n  text-align: left !important;\n}\n.width50 {\n  width: 50px;\n}\n.icon-delete {\n  font-size: 30px;\n  position: absolute;\n  top: 30px;\n  right: 2px;\n  background-color: rgba(255, 255, 255, 0.6);\n  border-radius: 50%;\n}\n.img-card {\n  position: relative;\n  width: 150px;\n  height: 150px;\n  margin-top: 10px;\n  overflow: hidden;\n}\n", ""]);

// exports
